export const sections = [
    {
        "id": "what-is-a-coworking-space",
        "heading": "What is a Coworking Space?",
        "subSections": []
    },
    {
        "id": "what-are-the-different-types-of-coworking-spaces",
        "heading": "What are the Different Types of Coworking Spaces?",
        "subSections": [
            {
                "id": "hot-desk",
                "heading": "Hot Desk"
            },
            {
                "id": "dedicated-fixed-desk",
                "title": "Dedicated/Fixed Desk"
            },
            {
                "id": "private-workspace",
                "title": "Private Workspace"
            }
        ]
    },
    {
        "id": "what-are-the-benefits-of-a-co-work-space",
        "heading": "What are the Benefits of a Co-Work Space?",
        "subSections": [
            {
                "id": "flexibility-and-making-the-impossible-possible",
                "title": "Flexibility and Making the Impossible, Possible"
            },
            {
                "id": "avoiding-that-hole-in-your-pocket",
                "title": "Avoiding that Hole in Your Pocket"
            },
            {
                "id": "creative-minds-think-alike",
                "title": "Creative Minds Think Alike"
            },
            {
                "id": "allows-you-to-mix-and-mingle",
                "title": "Allows You to Mix and Mingle"
            },
            {
                "id": "helps-you-get-work-done",
                "title": "Helps You Get Work Done"
            }
        ]
    },
    {
        "id": "how-to-find-the-ideal-coworking-space-for-my-business",
        "heading": "How to Find the Ideal Coworking Space for My Business?",
        "subSections": [
            {
                "id": "accessibility",
                "title": "Accessibility"
            },
            {
                "id": "amenities",
                "title": "Amenities"
            },
            {
                "id": "pricing",
                "title": "Pricing"
            },
            {
                "id": "aura",
                "title": "Aura"
            },
            {
                "id": "flexible-leases",
                "title": "Flexible Leases"
            }
        ]
    },
    {
        "id": "how-much-does-coworking-cost",
        "heading": "How Much Does Coworking Cost?",
        "subSections": []
    },
    {
        "id": "about-office-hub",
        "heading": "About Office Hub?",
        "subSections": []
    }
]
export const privateSections = [
    {
        id: "what-are-private-offices",
        heading: "What are Private Offices?",
        subSections: []
    },
    {
        id: "what-are-the-types-of-private-offices-i-can-choose-from",
        heading: "What are the Types of Private Offices I Can Choose From?",
        subSections: [
            {
                id: "serviced-offices",
                title: "Serviced Offices"
            },
            {
                id: "managed-offices",
                title: "Managed Offices"
            },
            {
                id: "leased-and-subleased-offices",
                title: "Leased and Subleased Offices"
            }
        ]
    },
    {
        id: "what-do-i-get-in-a-private-coworking-space",
        heading: "What Do I Get in a Private Coworking Space?",
        subSections: []
    },
    {
        id: "what-about-the-benefits",
        heading: "What About the Benefits?",
        subSections: [
            {
                id: "privacy",
                title: "Privacy"
            },
            {
                id: "reduced-cost",
                title: "Reduced Cost"
            },
            {
                id: "productivity",
                title: "Productivity"
            },
            {
                id: "brand-specific",
                title: "Brand Specific"
            }
        ]
    },
    {
        id: "what-about-the-cost",
        heading: "What About the Cost?",
        subSections: []
    },
    {
        id: "how-to-find-a-private-office-space",
        heading: "How to Find a Private Office Space?",
        subSections: []
    },
    {
        "id": "about-office-hub",
        "heading": "About Office Hub?",
        "subSections": []
    }
]
export const sharedSections = [
    {
        id: "what-are-shared-office-spaces",
        heading: "What are Shared Office Spaces?",
        subSections: [
            {
                id: "sublet-spaces",
                title: "Sublet Spaces"
            },
            {
                id: "spaces-made-uniquely-for-sharing",
                title: "Spaces Made Uniquely for Sharing"
            },
        ]
    },
    {
        id: "how-do-shared-office-spaces-work",
        heading: "How Do Shared Office Spaces Work?",
        subSections: [

        ]
    },
    {
        id: "what-are-the-pros-of-shared-office-spaces",
        heading: "What are the Pros of Shared Office Spaces?",
        subSections: [
            {
                id: "you-share-the-cost",
                title: "You Share the Cost"
            },
            {
                id: "easier-terms",
                title: "Easier Terms"
            },
            {
                id: "flexibility-for-employees",
                title: "Flexibility for Employees"
            },
            {
                id: "networking",
                title: "Networking"
            },
            {
                id: "preferred-locations",
                title: "Preferred Locations"
            },
            {
                id: "ideal-amenities",
                title: "Ideal Amenities"
            }
        ]
    },
    {
        id: "what-are-the-types-of-shared-office-spaces",
        heading: "What are the Types of Shared Office Spaces?",
        subSections: [
            {
                id: "dedicated-desk",
                title: "Dedicated Desk"
            },
            {
                id: "hot-desk",
                title: "Hot Desk"
            },
            {
                id: "private-offices",
                title: "Private Offices"
            }
        ]
    },
    {
        id: "what-should-shared-office-spaces-include",
        heading: "What Should Shared Office Spaces Include?",
        subSections: []
    },
    {
        id: "to-co-work-or-not-to-co-work",
        heading: "To Co-Work or Not to Co-Work?",
        subSections: []
    },
    {
        id: "how-do-i-find-a-shared-office-in-my-region",
        heading: "How Do I Find a Shared Office in My Region?",
        subSections: [
            {
                id: "invest-time-in-online-search",
                title: "Invest Time in Online Search"
            },
            {
                id: "sublet-your-space",
                title: "Sublet Your Space"
            },
            {
                id: "meet-office-hub-your-coworking-solution",
                title: "Meet Office Hub: Your Coworking Solution"
            }
        ]
    },
    {
        id: "about-office-hub",
        heading: "About Office Hub?",
        subSections: []
    }
]
export const hotDeskSections = [
    {
        id: "what-is-hot-desking",
        heading: "What is Hot Desking?",
        subSections: []
    },
    {
        id: "the-origins-of-hot-desking",
        heading: "The Origins of Hot Desking",
        subSections: []
    },
    {
        id: "top-benefits-of-hot-desks",
        heading: "3 Top Benefits of Hot Desks",
        subSections: [
            {
                id: "say-goodbye-to-expensive-office-arrangements",
                title: "Say Goodbye to Expensive Office Arrangements"
            },
            {
                id: "embrace-flexible-work-arrangements",
                title: "Embrace Flexible Work Arrangements"
            },
            {
                id: "the-comfort-of-the-office-away-from-the-office",
                title: "The Comfort of the Office, Away from the Office!"
            }
        ]
    },
    {
        id: "how-much-do-hot-desks-cost-on-average",
        heading: "How Much Do Hot Desks Cost on Average?",
        subSections: []
    },
    {
        id: "about-office-hub",
        heading: "About Office Hub?",
        subSections: []
    }
]
export const servicedSections = [
    {
        id: "what-is-a-serviced-office",
        heading: "What is a Serviced Office?",
        subSections: []
    },
    {
        id: "what-are-the-benefits-of-a-serviced-office",
        heading: "What are the Benefits of a Serviced Office?",
        subSections: [
            {
                id: "a-prime-location",
                title: "A Prime Location"
            },
            {
                id: "all-the-fixtures-and-fittings",
                title: "All the Fixtures and Fittings!"
            },
            {
                id: "flexible-lease-terms",
                title: "Flexible Lease Terms"
            },
            {
                id: "added-utilities",
                title: "Added Utilities"
            },
            {
                id: "growth-opportunities",
                title: "Growth Opportunities"
            }
        ]
    },
    {
        id: "what-kinds-of-businesses-benefit-from-serviced-offices",
        heading: "What Kinds of Businesses Benefit from Serviced Offices?",
        subSections: [
            {
                id: "start-ups",
                title: "Start-ups"
            },
            {
                id: "expansion",
                title: "Expansion"
            },
            {
                id: "flexible-work-structures",
                title: "Flexible Work Structures"
            }
        ]
    },
    {
        id: "is-a-serviced-office-going-to-be-an-expensive-choice",
        heading: "Is a Serviced Office Going to Be an Expensive Choice?",
        subSections: []
    },
    {
        id: "features-to-look-for-in-a-serviced-office",
        heading: "Features to Look for in a Serviced Office?",
        subSections: []
    },
    {
        id: "how-can-i-find-a-serviced-office-for-my-business",
        heading: "How Can I Find a Serviced Office for My Business?",
        subSections: []
    },
    {
        id: "about-office-hub",
        heading: "About Office Hub?",
        subSections: []
    }
]
export const virtualSections = [
    {
        id: "what-is-a-virtual-office",
        heading: "What is a Virtual Office?",
        subSections: []
    },
    {
        id: "what-do-you-get-with-a-virtual-office",
        heading: "What Do You Get with a Virtual Office?",
        subSections: []
    },
    {
        id: "what-should-you-consider-when-looking-for-a-virtual-office",
        heading: "What Should You Consider When Looking for a Virtual Office?",
        subSections: [
            {
                id: "location",
                title: "Location"
            },
            {
                id: "services",
                title: "Services"
            },
            {
                id: "cost",
                title: "Cost"
            }
        ]
    },
    {
        id: "the-pros-and-cons",
        heading: "The Pros and Cons",
        subSections: [
            {
                id: "the-pros",
                title: "The Pros"
            },
            {
                id: "the-cons",
                title: "The Cons"
            }
        ]
    },
    {
        id: "who-can-use-a-virtual-office",
        heading: "Who Can Use a Virtual Office?",
        subSections: [
            {
                id: "startups",
                title: "Startups"
            },
            {
                id: "freelancers",
                title: "Freelancers"
            },
            {
                id: "international-companies",
                title: "International Companies"
            }
        ]
    },
    {
        id: "how-office-hub-can-help",
        heading: "How Office Hub Can Help",
        subSections: []
    },
    {
        id: "about-office-hub",
        title: "About Office Hub?",
        subSections: []
    }
]
export const enterpriseSections = [
    {
        id: "what-are-the-features-of-an-enterprise-office-space",
        heading: "What are the Features of an Enterprise Office Space?",
        subSections: [
            {
                id: "size",
                title: "Size"
            },
            {
                id: "amenities",
                title: "Amenities"
            },
            {
                id: "security",
                title: "Security"
            },
            {
                id: "flexible-work",
                title: "Flexible Work"
            },
            {
                id: "aesthetics",
                title: "Aesthetics"
            }
        ]
    },
    {
        id: "what-are-the-benefits-of-enterprise-office-spaces",
        heading: "What are the Benefits of Enterprise Office Spaces",
        subSections: [
            {
                id: "centralized-location-for-employees",
                title: "Centralized Location for Employees"
            },
            {
                id: "team-building",
                title: "Team Building"
            },
            {
                id: "amenities-without-the-fuss",
                title: "Amenities without the Fuss"
            },
            {
                id: "company-culture",
                title: "Company Culture"
            },
            {
                id: "training",
                title: "Training"
            }
        ]
    },
    {
        id: "what-types-of-businesses-should-consider-an-enterprise-office-space",
        heading: "What Types of Businesses Should Consider an Enterprise Office Space?",
        subSections: [
            {
                id: "larger-corporations",
                title: "Larger Corporations"
            },
            {
                id: "multinational-companies",
                title: "Multinational Companies"
            }
        ]
    },
    {
        id: "how-can-i-search-for-an-enterprise-office-space-near-me",
        heading: "How Can I Search for an Enterprise Office Space Near Me?",
        subSections: [

        ]
    },
    {
        id: "office-hub-the-coworking-solution",
        heading: "Office Hub: The Coworking Solution",
        subSections: []
    },
    {
        id: "about-office-hub",
        title: "About Office Hub?",
        subSections: []
    }
]
export const subletSections = [
    {
        id: "what-is-a-sublet-office-space",
        heading: "What is a Sublet Office Space?",
        subSections: []
    },
    {
        id: "is-a-sublet-office-space-cheaper",
        heading: "Is a Sublet Office Space Cheaper?",
        subSections: []
    },
    {
        id: "key-considerations",
        heading: "Key Considerations",
        subSections: [
            {
                id: "cutting-the-cost",
                title: "Cutting the Cost"
            },
            {
                id: "flexible-work-arrangements",
                title: "Flexible Work Arrangements"
            },
            {
                id: "convenience",
                title: "Convenience"
            },
            {
                id: "networking",
                title: "Networking"
            },
            {
                id: "growth",
                title: "Growth"
            }
        ]
    },
    {
        id: "typical-sublet-office-space-occupiers",
        heading: "Typical Sublet Office Space Occupiers",
        subSections: []
    },
    {
        id: "the-cost-of-a-typical-sublet-office-space",
        heading: "The Cost of a Typical Sublet Office Space",
        subSections: []
    },
    {
        id: "what-to-look-for-in-a-sublet-office-space",
        heading: "What to Look for in a Sublet Office Space?",
        subSections: [
            {
                id: "the-location",
                title: "The Location"
            },
            {
                id: "the-cost",
                title: "The Cost"
            },
            {
                id: "the-amenities",
                title: "The Amenities"
            },
            {
                id: "the-right-provider",
                title: "The Right Provider"
            }
        ]
    },
    {
        id: "about-office-hub",
        heading: "About Office Hub?",
        subSections: []
    }
]
